<template>
  <MasterLayout>
    <div class="new-staff">
      <div class="add_new_bank_account_header">
        <p>
          {{ mode == "create" ? "Create station space" : "Edit Branch space " }}
        </p>
      </div>
      <div class="cover">
        <div class="personal">
          <div class="row">
            <div class="input__group__block mt-4 col-md-6">
              <label class="required">
                <span class="mylabel">
                  {{ $t("text.cBranchLease.selectBranch") }}
                </span>
              </label>
              <div class="price_change_input_wrapper">
                <model-select
                  :options="branches"
                  v-model="branchId"
                  :placeholder="$t('text.cBranchLease.selectBranch')"
                >
                </model-select>
              </div>
            </div>
            <div class="input__group__block mt-4 col-md-6">
              <label class="required">
                <span class="mylabel">
                  {{ $t("text.cBranchLease.propertyName") }}
                </span>
              </label>
              <div class="price_change_input_wrapper">
                <input
                  type="text"
                  placeholder="Property name"
                  v-model="formData.propertyName"
                  class="border-0"
                />
              </div>
            </div>
            <div class="input__group__block mt-4 col-md-6">
              <label class="required">
                <span class="mylabel">
                  {{ $t("text.cBranchLease.propertyDescription") }}
                </span>
              </label>
              <div class="price_change_input_wrapper">
                <input
                  type="text"
                  :placeholder="$t('text.cBranchLease.propertyDescription')"
                  v-model="formData.propertyDescription"
                  class="border-0"
                />
              </div>
            </div>

            <div class="input__group__block mt-4 col-md-6">
              <label class="required">
                <span class="mylabel">
                  {{ $t("text.cBranchLease.rooms") }}
                </span>
              </label>
              <div class="price_change_input_wrapper">
                <input
                  type="number"
                  :placeholder="$t('text.cBranchLease.rooms')"
                  v-model="formData.numberOfRooms"
                  class="border-0"
                />
              </div>
            </div>
            <div class="input__group__block mt-4 col-md-6">
              <label class="required">
                <span class="mylabel">
                  {{ $t("text.cBranchLease.restRoom") }}
                </span>
              </label>
              <div class="price_change_input_wrapper">
                <input
                  type="number"
                  :placeholder="$t('text.cBranchLease.restRoom')"
                  v-model="formData.numberOfRestRooms"
                  class="border-0"
                />
              </div>
            </div>
            <div class="input__group__block mt-4 col-md-6">
              <label>
                <span class="mylabel">
                  {{ $t("text.cBranchLease.addtional") }}
                </span>
              </label>
              <div class="price_change_input_wrapper">
                <input
                  type="text"
                  :placeholder="$t('text.cBranchLease.addtional')"
                  v-model="formData.additionalDetails"
                  class="border-0"
                />
              </div>
            </div>

            <!-- duration array  -->

            <section
              class="row col-md-12 my-4 pb-4 px-0 mx-auto align-items-center rent-entry"
            >
              <section
                v-for="(entry, index) in rentEntries"
                :key="index"
                class="row col-md-12 px-0 mx-auto align-items-center"
              >
                <div class="input__group__block mt-4 rent-duration">
                  <label class="required">
                    <span class="mylabel">
                      {{ $t("text.cBranchLease.rentDuration") }}
                    </span>
                  </label>
                  <div class="price_change_input_wrapper">
                    <select v-model="entry.name">
                      <option value="null" selected disabled>
                        {{ $t("text.cBranchLease.rentDuration") }}
                      </option>
                      <option value="yearly">
                        <span>
                          {{ $t("text.cBranchLease.yearly") }}
                        </span>
                      </option>

                      <option value="monthly">
                        <span>
                          {{ $t("text.cBranchLease.monthly") }}
                        </span>
                      </option>

                      <option value="weekly">
                        <span>
                          {{ $t("text.cBranchLease.weekly") }}
                        </span>
                      </option>
                    </select>
                    <!-- <input
                      type="text"
                      :placeholder="$t('text.cBranchLease.rentDuration')"
                      v-model="entry.name"
                      class="border-0"
                    /> -->
                  </div>
                </div>
                <div class="input__group__block mt-4 rent-fee">
                  <label class="required">
                    <span class="mylabel">
                      {{ $t("text.cBranchLease.rentFee") }}
                    </span>
                  </label>
                  <div class="price_change_input_wrapper">
                    <input
                      type="number"
                      :placeholder="$t('text.cBranchLease.rentFee')"
                      v-model="entry.durationPrice"
                      class="border-0"
                    />
                  </div>
                </div>
                <div class="text-center mb-2 rent-cancel">
                  <button @click="removeEntry(index)" class="remove-button">
                    &times;
                  </button>
                </div>
              </section>
              <div class="d-flex justify-content-center w-100 mt-3">
                <button @click="addEntry" class="add-button">
                  {{ $t("text.editProductModal.addMore") }}
                </button>
              </div>
            </section>

            <div class="col-md-6"></div>
          </div>
        </div>
        <div class="text-center mt-4 pb-4">
          <button
            :disabled="isButtonDisabled ? true : false"
            class="ep-btn ep-primary"
            @click="
              mode === 'create'
                ? createBranchSpace($event)
                : updateSpace($event)
            "
          >
            {{ mode == "create" ? "Create" : "Update" }}
          </button>
          <img
            src="@/assets/img/git_loader.gif"
            style="display: none"
            width="35px"
            class="ml-3 loader"
          />
        </div>
      </div>
    </div>
  </MasterLayout>
</template>

<script>
import MasterLayout from "@/views/Company/MasterLayout.vue";
import configObject from "@/config";
import VueTagsInput from "@johmun/vue-tags-input";
import PulseLoader from "vue-spinner/src/PulseLoader.vue";
import "vue-search-select/dist/VueSearchSelect.css";
import { ModelSelect } from "vue-search-select";

import JQuery from "jquery";
let $ = JQuery;

export default {
  title: "Create station space :: Epump Portal",
  name: "AddStaff",
  components: {
    MasterLayout,
    VueTagsInput,
    PulseLoader,
    ModelSelect,
  },
  data() {
    return {
      company: "",
      branches: [],
      branchId: null,
      formData: {
        propertyName: "",
        propertyDescription: "",
        rentFee: 0,
        numberOfRooms: 0,
        numberOfRestRooms: 0,
        additionalDetails: "",
        rentDuration: "",
      },
      rentEntries: [{ name: "", durationPrice: "" }],
      branchSpaces: [],
      branchSpace: "",
      mode: "create",
      isButtonDisabled: false,
    };
  },
  watch: {
    company(company) {
      if (company !== null) {
        this.getBranches();
      }
    },
  },
  created() {
    this.$eventHub.$on("company", (company) => {
      this.company = company;
    });
  },
  mounted() {
    if (this.$route.query.spaceId) {
      this.mode = "edit";
      this.getBranchSpace();
    }
  },
  beforeDestroy() {},
  methods: {
    //utilities
    addEntry() {
      this.rentEntries.push({ name: "", durationPrice: "" });
    },
    removeEntry(index) {
      if (this.rentEntries.length <= 1) return;
      this.rentEntries.splice(index, 1);
    },
    //
    getBranches() {
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Company/Branches/${
            this.$route.query.companyId
              ? this.$route.query.companyId
              : this.company.id
          }`,
          configObject.authConfig()
        )
        .then((res) => {
          res.data.sort((a, b) => {
            return a.name.toLowerCase() > b.name.toLowerCase()
              ? 1
              : b.name.toLowerCase() > a.name.toLowerCase()
              ? -1
              : 0;
          });

          this.branches = res.data;
          this.branches.forEach((el) => {
            el.text = el.name;
            el.value = el.id;
          });
        })
        .catch((error) => {});
    },
    getBranchSpace() {
      this.showLoader = true;
      this.axios
        .get(
          `${configObject.apiBaseUrl}/BranchSpace/Get/All/${this.branchId}`,
          configObject.authConfig()
        )
        .then((response) => {
          response.data.forEach((el) => {
            el.text = el.name;
            el.value = el.id;
          });
          this.branchSpaces = response.data;
        })
        .catch((error) => {
          this.showLoader = false;
        });
    },
    createBranchSpace($event) {
      $event.preventDefault();
      if (!this.formData.propertyName) {
        this.$toast.open({
          message: this.$t("text.errors.propertyNameRequired"),
          type: "error",
          duration: 3000,
        });
        return;
      }
      if (!this.formData.propertyDescription) {
        this.$toast.open({
          message: this.$t("text.errors.propertyDescriptionRequired"),
          type: "error",
          duration: 3000,
        });
        return;
      }

      if (!this.formData.numberOfRooms) {
        this.$toast.open({
          message: this.$t("text.errors.roomsRequired"),
          type: "error",
          duration: 3000,
        });
        return;
      }
      if (!this.formData.numberOfRestRooms) {
        this.$toast.open({
          message: this.$t("text.errors.restroomRequired"),
          type: "error",
          duration: 3000,
        });
        return;
      }

      // if (!this.formData.additionalDetails) {
      //   this.$toast.open({
      //     message: this.$t("text.errors.detailsRequired"),
      //     type: "error",
      //     duration: 3000,
      //   });
      //   return;
      // }

      if (
        !this.rentEntries.every((entry) => entry.name && entry.durationPrice)
      ) {
        this.$toast.open({
          message: this.$t("text.errors.rentDurationRequired"),
          type: "error",
          duration: 3000,
        });
        return;
      }

      let data = {
        branchId: this.branchId,
        propertyName: this.formData.propertyName,
        propertyDescription: this.formData.propertyDescription,
        numberOfRooms: Number(this.formData.numberOfRooms),
        numberOfRestRooms: Number(this.formData.numberOfRestRooms),
        additionalDetails: this.formData.additionalDetails,
        rentDurations: this.rentEntries,

        // rentFee: Number(this.formData.rentFee),
      };

      this.isButtonDisabled = true;
      $(".loader").show();
      this.axios
        .post(
          `${configObject.apiBaseUrl}/BranchSpace/Post`,
          data,
          configObject.authConfig()
        )
        .then(() => {
          this.$router.push({
            name: "companyBranchSpace",
            query: {
              companyId: this.$route.query.companyId,
              branchId: this.$route.query.branchId,
            },
          });
          this.$toast.open({
            message: this.$t("text.errors.updatedBranchSpace"),
            type: "success",
            duration: 5000,
          });
          $(".loader").hide();
          this.isButtonDisabled = false;
        })
        .catch((error) => {
          this.$toast.open({
            message: error.response.data.message,
            type: "error",
            duration: 5000,
          });
          this.isButtonDisabled = false;
          $(".loader").hide();
        });
    },
    updateSpace($event) {
      $event.preventDefault();
      if (!this.formData.propertyName) {
        this.$toast.open({
          message: this.$t("text.errors.propertyNameRequired"),
          type: "error",
          duration: 3000,
        });
        return;
      }
      if (!this.formData.propertyDescription) {
        this.$toast.open({
          message: this.$t("text.errors.propertyDescriptionRequired"),
          type: "error",
          duration: 3000,
        });
        return;
      }
      if (!this.formData.rentFee) {
        this.$toast.open({
          message: this.$t("text.errors.rentFeeRequired"),
          type: "error",
          duration: 3000,
        });
        return;
      }
      if (!this.formData.numberOfRooms) {
        this.$toast.open({
          message: this.$t("text.errors.roomsRequired"),
          type: "error",
          duration: 3000,
        });
        return;
      }
      if (!this.formData.numberOfRestRooms) {
        this.$toast.open({
          message: this.$t("text.errors.restroomRequired"),
          type: "error",
          duration: 3000,
        });
        return;
      }

      if (!this.formData.additionalDetails) {
        this.$toast.open({
          message: this.$t("text.errors.detailsRequired"),
          type: "error",
          duration: 3000,
        });
        return;
      }
      if (!this.formData.rentDuration) {
        this.$toast.open({
          message: this.$t("text.errors.rentDurationRequired"),
          type: "error",
          duration: 3000,
        });
        return;
      }
      let data = {
        propertyName: this.formData.propertyName,
        propertyDescription: this.formData.propertyDescription,
        rentFee: Number(this.formData.rentFee),
        numberOfRooms: Number(this.formData.numberOfRooms),
        numberOfRestRooms: Number(this.formData.numberOfRestRooms),
        additionalDetails: this.formData.additionalDetails,
        rentDuration: this.formData.rentDuration,
      };

      this.isButtonDisabled = true;
      $(".loader").show();

      this.axios
        .put(
          `${configObject.apiBaseUrl}/BranchSpace/Edit/${this.$route.query.spaceId}`,
          data,
          configObject.authConfig()
        )
        .then(() => {
          this.$router.push({
            name: "companyBranchSpace",
            query: {
              companyId: this.$route.query.companyId,
              branchId: this.$route.query.branchId,
            },
          });
          // this.$router.push({
          //   name: "CompanyBranchSpace",
          //   query: {
          //     companyId: this.$route.query.companyId,
          //     branchId: this.$route.query.id,
          //   },
          // });
          this.$toast.open({
            message: this.$t("text.errors.updatedBranchSpace"),
            type: "success",
            duration: 5000,
          });
          $(".loader").hide();
          this.isButtonDisabled = false;
        })
        .catch((error) => {
          this.$toast.open({
            message: error.response.data.message,
            type: "error",
            duration: 5000,
          });
          this.isButtonDisabled = false;
          $(".loader").hide();
        });
    },
    getBranchSpace() {
      this.showLoader = true;
      this.axios
        .get(
          `${configObject.apiBaseUrl}/BranchSpace/Get/${this.$route.query.spaceId}`,
          configObject.authConfig()
        )
        .then((response) => {
          // console.log(response.data);
          this.formData = response.data;
          this.formData.propertyName = response.data.name;
          this.formData.propertyDescription = response.data.description;
          this.formData.numberOfRooms = response.data.rooms;
          this.formData.numberOfRestRooms = response.data.restrooms;
        })
        .catch((error) => {
          this.showLoader = false;
        });
    },
  },
};
</script>
<style scoped>
.rent-entry {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-top: 1px solid gray;
  border-bottom: 1px solid gray;
}

.rent-duration,
.rent-fee {
  width: 45%;
}

.rent-cancel {
  width: 4%;
  align-self: flex-end;
}

@media (max-width: 768px) {
  .rent-duration,
  .rent-fee,
  .rent-cancel {
    width: 100%;
    margin-bottom: 1rem;
  }
}

.remove-button {
  background-color: #ff4d4f;
  color: white;
  padding: 4px 8px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  width: 100%;
}

.add-button {
  background-color: #1890ff;
  color: white;
  padding: 8px 16px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}
</style>
